// extracted by mini-css-extract-plugin
export default {"selectedValue":"customer_selectedValue__ezf37","ant-select-selector":"customer_ant-select-selector__69pzq"};